import { colorFillAlter, colorText, ConfigProvider, Select } from '@arkestro/arkestro-design-system';

export interface UnitSelectOption<T extends string> {
  label: string;
  value: T;
}

interface UnitSelectProps<T extends string> {
  dataTestId: string;
  disabled?: boolean;
  onChange: (value: T) => void;
  options: UnitSelectOption<T>[];
  value: T;
}

export const UnitSelect = <T extends string>({ dataTestId, disabled, onChange, options, value }: UnitSelectProps<T>) => (
  <ConfigProvider theme={{ components: { Select: { colorBgContainer: colorFillAlter, colorText } } }}>
    <Select data-testid={dataTestId} disabled={disabled} onChange={onChange} options={options} value={value} />
  </ConfigProvider>
);
